import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    exchangesAdminControllerCreateExchangeV1: build.mutation<
      ExchangesAdminControllerCreateExchangeV1ApiResponse,
      ExchangesAdminControllerCreateExchangeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges`,
        method: 'POST',
        body: queryArg.createExchangeBody,
      }),
    }),
    exchangesAdminControllerListExchangesV1: build.query<
      ExchangesAdminControllerListExchangesV1ApiResponse,
      ExchangesAdminControllerListExchangesV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges`,
        params: {
          ipScope: queryArg.ipScope,
        },
      }),
    }),
    exchangesAdminControllerGetExchangeV1: build.query<
      ExchangesAdminControllerGetExchangeV1ApiResponse,
      ExchangesAdminControllerGetExchangeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}`,
        params: {
          ipScope: queryArg.ipScope,
        },
      }),
    }),
    exchangesAdminControllerUpdateExchangeV1: build.mutation<
      ExchangesAdminControllerUpdateExchangeV1ApiResponse,
      ExchangesAdminControllerUpdateExchangeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateExchangeBody,
      }),
    }),
    exchangesAdminControllerDeleteExchangeV1: build.mutation<
      ExchangesAdminControllerDeleteExchangeV1ApiResponse,
      ExchangesAdminControllerDeleteExchangeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    exchangesAdminSyncControllerSyncExchangeV1: build.mutation<
      ExchangesAdminSyncControllerSyncExchangeV1ApiResponse,
      ExchangesAdminSyncControllerSyncExchangeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/sync`,
        method: 'POST',
      }),
    }),
    exchangesAdminSyncControllerGetExchangeChangelogsV1: build.query<
      ExchangesAdminSyncControllerGetExchangeChangelogsV1ApiResponse,
      ExchangesAdminSyncControllerGetExchangeChangelogsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/changelogs`,
      }),
    }),
    exchangesAdminSyncControllerGetExchangeSyncLogsV1: build.query<
      ExchangesAdminSyncControllerGetExchangeSyncLogsV1ApiResponse,
      ExchangesAdminSyncControllerGetExchangeSyncLogsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/synclogs`,
      }),
    }),
    exchangesControllerListExchangesRootV1: build.query<
      ExchangesControllerListExchangesRootV1ApiResponse,
      ExchangesControllerListExchangesRootV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/exchanges`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    exchangeIpsAdminControllerListExchangeIpsV1: build.query<
      ExchangeIpsAdminControllerListExchangeIpsV1ApiResponse,
      ExchangeIpsAdminControllerListExchangeIpsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/ips`,
        params: {
          usage: queryArg.usage,
        },
      }),
    }),
    exchangeIpsAdminControllerCreateExchangeIpV1: build.mutation<
      ExchangeIpsAdminControllerCreateExchangeIpV1ApiResponse,
      ExchangeIpsAdminControllerCreateExchangeIpV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/ips`,
        method: 'POST',
        body: queryArg.createExchangeIpBody,
      }),
    }),
    exchangeIpsAdminControllerUpdateExchangeIpV1: build.mutation<
      ExchangeIpsAdminControllerUpdateExchangeIpV1ApiResponse,
      ExchangeIpsAdminControllerUpdateExchangeIpV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/ips/${queryArg.ipId}`,
        method: 'PUT',
        body: queryArg.updateExchangeIpBody,
      }),
    }),
    exchangeIpsAdminControllerDeleteExchangeIpV1: build.mutation<
      ExchangeIpsAdminControllerDeleteExchangeIpV1ApiResponse,
      ExchangeIpsAdminControllerDeleteExchangeIpV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/ips/${queryArg.ipId}`,
        method: 'DELETE',
      }),
    }),
    exchangeRegionsAdminControllerListExchangeRegionsV1: build.query<
      ExchangeRegionsAdminControllerListExchangeRegionsV1ApiResponse,
      ExchangeRegionsAdminControllerListExchangeRegionsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/regions`,
      }),
    }),
    exchangeRegionsAdminControllerCreateExchangeRegionV1: build.mutation<
      ExchangeRegionsAdminControllerCreateExchangeRegionV1ApiResponse,
      ExchangeRegionsAdminControllerCreateExchangeRegionV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/regions`,
        method: 'POST',
        body: queryArg.createExchangeRegionBody,
      }),
    }),
    exchangeRegionsAdminControllerDeleteExchangeRegionV1: build.mutation<
      ExchangeRegionsAdminControllerDeleteExchangeRegionV1ApiResponse,
      ExchangeRegionsAdminControllerDeleteExchangeRegionV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/exchanges/${queryArg.id}/regions/${queryArg.linkId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ExchangesAdminControllerCreateExchangeV1ApiResponse =
  /** status 200 Returns created exchange */ CreateExchangeResponse;
export type ExchangesAdminControllerCreateExchangeV1ApiArg = {
  createExchangeBody: CreateExchangeBody;
};
export type ExchangesAdminControllerListExchangesV1ApiResponse =
  /** status 200 Returns the list of exchanges */ ListExchangesResponse;
export type ExchangesAdminControllerListExchangesV1ApiArg = {
  /** Which IPs to include: a comma-separated list of monitoring, api, trading, all. Several may be given and the union is returned. */
  ipScope?: string;
};
export type ExchangesAdminControllerGetExchangeV1ApiResponse =
  /** status 200 Exchange details */ GetExchangeResponse;
export type ExchangesAdminControllerGetExchangeV1ApiArg = {
  /** Which IPs to include: a comma-separated list of monitoring, api, trading, all. Several may be given and the union is returned. */
  ipScope?: string;
  id: number;
};
export type ExchangesAdminControllerUpdateExchangeV1ApiResponse =
  /** status 200 Returns updated exchange */ UpdateExchangeResponse;
export type ExchangesAdminControllerUpdateExchangeV1ApiArg = {
  id: number;
  updateExchangeBody: UpdateExchangeBody;
};
export type ExchangesAdminControllerDeleteExchangeV1ApiResponse =
  /** status 200 Returns deleted exchange */ DeleteExchangeResponse;
export type ExchangesAdminControllerDeleteExchangeV1ApiArg = {
  id: number;
};
export type ExchangesAdminSyncControllerSyncExchangeV1ApiResponse =
  /** status 200 Sync request queued */ SyncExchangeResponse;
export type ExchangesAdminSyncControllerSyncExchangeV1ApiArg = {
  id: number;
};
export type ExchangesAdminSyncControllerGetExchangeChangelogsV1ApiResponse =
  /** status 200 Returns the exchange APIs, each with their most recent changelog entries */ GetExchangeChangelogsResponse;
export type ExchangesAdminSyncControllerGetExchangeChangelogsV1ApiArg = {
  id: number;
};
export type ExchangesAdminSyncControllerGetExchangeSyncLogsV1ApiResponse =
  /** status 200 Returns sync logs for the exchange */ GetExchangeSyncLogsResponse;
export type ExchangesAdminSyncControllerGetExchangeSyncLogsV1ApiArg = {
  id: number;
};
export type ExchangesControllerListExchangesRootV1ApiResponse =
  /** status 200 Returns the list of exchanges for MM or ES scope. Default is MM. */ Blob;
export type ExchangesControllerListExchangesRootV1ApiArg = {
  /** Scope of the exchange list */
  scope?: 'mm' | 'es';
};
export type ExchangeIpsAdminControllerListExchangeIpsV1ApiResponse =
  /** status 200 Returns the IP addresses of the exchange */ ListExchangeIpsResponse;
export type ExchangeIpsAdminControllerListExchangeIpsV1ApiArg = {
  id: number;
  /** Transport to filter by: mm or es */
  usage?: string;
};
export type ExchangeIpsAdminControllerCreateExchangeIpV1ApiResponse =
  /** status 200 Returns the created IP address */ CreateExchangeIpResponse;
export type ExchangeIpsAdminControllerCreateExchangeIpV1ApiArg = {
  id: number;
  createExchangeIpBody: CreateExchangeIpBody;
};
export type ExchangeIpsAdminControllerUpdateExchangeIpV1ApiResponse =
  /** status 200 Returns the updated IP address */ UpdateExchangeIpResponse;
export type ExchangeIpsAdminControllerUpdateExchangeIpV1ApiArg = {
  id: number;
  ipId: number;
  updateExchangeIpBody: UpdateExchangeIpBody;
};
export type ExchangeIpsAdminControllerDeleteExchangeIpV1ApiResponse =
  /** status 200 Returns the deleted IP address */ DeleteExchangeIpResponse;
export type ExchangeIpsAdminControllerDeleteExchangeIpV1ApiArg = {
  id: number;
  ipId: number;
};
export type ExchangeRegionsAdminControllerListExchangeRegionsV1ApiResponse =
  /** status 200 Returns the region links of the exchange */ ListExchangeRegionsResponse;
export type ExchangeRegionsAdminControllerListExchangeRegionsV1ApiArg = {
  id: number;
};
export type ExchangeRegionsAdminControllerCreateExchangeRegionV1ApiResponse =
  /** status 200 Returns the created link */ CreateExchangeRegionResponse;
export type ExchangeRegionsAdminControllerCreateExchangeRegionV1ApiArg = {
  id: number;
  createExchangeRegionBody: CreateExchangeRegionBody;
};
export type ExchangeRegionsAdminControllerDeleteExchangeRegionV1ApiResponse =
  /** status 200 Returns the deleted link */ DeleteExchangeRegionResponse;
export type ExchangeRegionsAdminControllerDeleteExchangeRegionV1ApiArg = {
  id: number;
  linkId: number;
};
export type CreateExchangeResponse = {
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id: number;
  /** Is ES exchange */
  isES: boolean;
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker: string;
  /** Comment (nullable) */
  comment: null | string;
  /** Public key length */
  pubLength: number;
  /** Public key mask */
  pubMask: string;
  /** Secret key length */
  secretLength: number;
  /** Secret key mask */
  secretMask: string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly: boolean;
  /** Is passphrase optional? */
  passphraseOptional: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize: null | number;
  /** Video URL (nullable) */
  video: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator: string;
  /** Bot name (nullable) */
  botName: null | string;
  /** Whether the exchange is active or not */
  isActive: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Date of the latest API changelog entry */
  lastChangelogAt?: null | string;
  /** Date of the most recent successful exchange sync */
  lastSyncedAt?: null | string;
  /** MM IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsMM?: string;
  /** ES IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsES?: string;
  /** The MM IPs the exchange owns directly, a subset of `ipsMM`. What is in `ipsMM` but not here was inherited from the regions in `regionsMM` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsMM?: string;
  /** The ES IPs the exchange owns directly, a subset of `ipsES`. What is in `ipsES` but not here was inherited from the regions in `regionsES` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsES?: string;
  /** Regions the exchange inherits its MM IPs from, in link order */
  regionsMM?: {
    id: number;
    name: string;
  }[];
  /** Regions the exchange inherits its ES IPs from, in link order */
  regionsES?: {
    id: number;
    name: string;
  }[];
};
export type BadRequestError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** The i18n key of the error, stable across languages */
  code: string;
  /** On BAD_REQUEST_VALIDATION: one entry per failed field */
  errors?: {
    path: string;
    message: string;
    [key: string]: any;
  }[];
};
export type ForbiddenError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** The i18n key of the error, stable across languages */
  code: string;
};
export type CreateExchangeBody = {
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker: string;
  /** Public key length */
  pubLength: number;
  /** Public key mask */
  pubMask: string;
  /** Secret key length */
  secretLength: number;
  /** Secret key mask */
  secretMask: string;
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id?: number;
  /** Is ES exchange */
  isES?: boolean;
  /** Comment (nullable) */
  comment?: null | string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase?: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel?: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly?: boolean;
  /** Is passphrase optional? */
  passphraseOptional?: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize?: null | number;
  /** Video URL (nullable) */
  video?: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator?: string;
  /** Bot name (nullable) */
  botName?: null | string;
  /** Whether the exchange is active or not */
  isActive?: boolean;
};
export type ListExchangesResponse = {
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id: number;
  /** Is ES exchange */
  isES: boolean;
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker: string;
  /** Comment (nullable) */
  comment: null | string;
  /** Public key length */
  pubLength: number;
  /** Public key mask */
  pubMask: string;
  /** Secret key length */
  secretLength: number;
  /** Secret key mask */
  secretMask: string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly: boolean;
  /** Is passphrase optional? */
  passphraseOptional: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize: null | number;
  /** Video URL (nullable) */
  video: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator: string;
  /** Bot name (nullable) */
  botName: null | string;
  /** Whether the exchange is active or not */
  isActive: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Date of the latest API changelog entry */
  lastChangelogAt?: null | string;
  /** Date of the most recent successful exchange sync */
  lastSyncedAt?: null | string;
  /** MM IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsMM?: string;
  /** ES IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsES?: string;
  /** The MM IPs the exchange owns directly, a subset of `ipsMM`. What is in `ipsMM` but not here was inherited from the regions in `regionsMM` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsMM?: string;
  /** The ES IPs the exchange owns directly, a subset of `ipsES`. What is in `ipsES` but not here was inherited from the regions in `regionsES` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsES?: string;
  /** Regions the exchange inherits its MM IPs from, in link order */
  regionsMM?: {
    id: number;
    name: string;
  }[];
  /** Regions the exchange inherits its ES IPs from, in link order */
  regionsES?: {
    id: number;
    name: string;
  }[];
}[];
export type GetExchangeResponse = {
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id: number;
  /** Is ES exchange */
  isES: boolean;
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker: string;
  /** Comment (nullable) */
  comment: null | string;
  /** Public key length */
  pubLength: number;
  /** Public key mask */
  pubMask: string;
  /** Secret key length */
  secretLength: number;
  /** Secret key mask */
  secretMask: string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly: boolean;
  /** Is passphrase optional? */
  passphraseOptional: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize: null | number;
  /** Video URL (nullable) */
  video: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator: string;
  /** Bot name (nullable) */
  botName: null | string;
  /** Whether the exchange is active or not */
  isActive: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Date of the latest API changelog entry */
  lastChangelogAt?: null | string;
  /** Date of the most recent successful exchange sync */
  lastSyncedAt?: null | string;
  /** MM IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsMM?: string;
  /** ES IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsES?: string;
  /** The MM IPs the exchange owns directly, a subset of `ipsMM`. What is in `ipsMM` but not here was inherited from the regions in `regionsMM` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsMM?: string;
  /** The ES IPs the exchange owns directly, a subset of `ipsES`. What is in `ipsES` but not here was inherited from the regions in `regionsES` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsES?: string;
  /** Regions the exchange inherits its MM IPs from, in link order */
  regionsMM?: {
    id: number;
    name: string;
  }[];
  /** Regions the exchange inherits its ES IPs from, in link order */
  regionsES?: {
    id: number;
    name: string;
  }[];
};
export type UpdateExchangeResponse = {
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id: number;
  /** Is ES exchange */
  isES: boolean;
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker: string;
  /** Comment (nullable) */
  comment: null | string;
  /** Public key length */
  pubLength: number;
  /** Public key mask */
  pubMask: string;
  /** Secret key length */
  secretLength: number;
  /** Secret key mask */
  secretMask: string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly: boolean;
  /** Is passphrase optional? */
  passphraseOptional: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize: null | number;
  /** Video URL (nullable) */
  video: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator: string;
  /** Bot name (nullable) */
  botName: null | string;
  /** Whether the exchange is active or not */
  isActive: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Date of the latest API changelog entry */
  lastChangelogAt?: null | string;
  /** Date of the most recent successful exchange sync */
  lastSyncedAt?: null | string;
  /** MM IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsMM?: string;
  /** ES IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsES?: string;
  /** The MM IPs the exchange owns directly, a subset of `ipsMM`. What is in `ipsMM` but not here was inherited from the regions in `regionsMM` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsMM?: string;
  /** The ES IPs the exchange owns directly, a subset of `ipsES`. What is in `ipsES` but not here was inherited from the regions in `regionsES` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsES?: string;
  /** Regions the exchange inherits its MM IPs from, in link order */
  regionsMM?: {
    id: number;
    name: string;
  }[];
  /** Regions the exchange inherits its ES IPs from, in link order */
  regionsES?: {
    id: number;
    name: string;
  }[];
};
export type UpdateExchangeBody = {
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id?: number;
  /** Is ES exchange */
  isES?: boolean;
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name?: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker?: string;
  /** Comment (nullable) */
  comment?: null | string;
  /** Public key length */
  pubLength?: number;
  /** Public key mask */
  pubMask?: string;
  /** Secret key length */
  secretLength?: number;
  /** Secret key mask */
  secretMask?: string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase?: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel?: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly?: boolean;
  /** Is passphrase optional? */
  passphraseOptional?: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize?: null | number;
  /** Video URL (nullable) */
  video?: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator?: string;
  /** Bot name (nullable) */
  botName?: null | string;
  /** Whether the exchange is active or not */
  isActive?: boolean;
};
export type DeleteExchangeResponse = {
  /** Exchange ID. Must match the id the MM/ES trading backends use for this exchange, so it can be assigned explicitly on create and corrected on update; omit on create to auto-assign. The backend ticker-to-id map lives outside this service, so only uniqueness is validated here — assigning an id that the backends associate with a different ticker silently misroutes that exchange. */
  id: number;
  /** Is ES exchange */
  isES: boolean;
  /** Exchange name (1-255 chars, alphanumeric, dot, hyphen, underscore) */
  name: string;
  /** Exchange ticker (2-4 uppercase letters/numbers) */
  ticker: string;
  /** Comment (nullable) */
  comment: null | string;
  /** Public key length */
  pubLength: number;
  /** Public key mask */
  pubMask: string;
  /** Secret key length */
  secretLength: number;
  /** Secret key mask */
  secretMask: string;
  /** Whether the exchange requires a passphrase or additional parameter for subaccount authentication */
  passphrase: boolean;
  /** Passphrase label (nullable) */
  passphraseLabel: null | string;
  /** Whether the passphrase can only contain numbers */
  passphraseNumbersOnly: boolean;
  /** Is passphrase optional? */
  passphraseOptional: boolean;
  /** Minimum order size, in USD (nullable) */
  minOrderSize: null | number;
  /** Video URL (nullable) */
  video: null | string;
  /** IPs separator (commas and/or spaces) */
  ipsSeparator: string;
  /** Bot name (nullable) */
  botName: null | string;
  /** Whether the exchange is active or not */
  isActive: boolean;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Date of the latest API changelog entry */
  lastChangelogAt?: null | string;
  /** Date of the most recent successful exchange sync */
  lastSyncedAt?: null | string;
  /** MM IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsMM?: string;
  /** ES IPs, resolved from the exchange's own IP addresses and those of the regions it links, joined with `ipsSeparator` */
  ipsES?: string;
  /** The MM IPs the exchange owns directly, a subset of `ipsMM`. What is in `ipsMM` but not here was inherited from the regions in `regionsMM` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsMM?: string;
  /** The ES IPs the exchange owns directly, a subset of `ipsES`. What is in `ipsES` but not here was inherited from the regions in `regionsES` — which is the only way to tell an exchange that owns IPs on top of a region from one that merely links it */
  ownIpsES?: string;
  /** Regions the exchange inherits its MM IPs from, in link order */
  regionsMM?: {
    id: number;
    name: string;
  }[];
  /** Regions the exchange inherits its ES IPs from, in link order */
  regionsES?: {
    id: number;
    name: string;
  }[];
};
export type SyncExchangeResponse = {
  success: boolean;
  message: string;
};
export type GetExchangeChangelogsResponse = {
  /** API ID */
  id: number;
  /** Exchange ID */
  exchangeId: number;
  /** API name */
  name: string;
  /** API version */
  version: string;
  /** Base URL (nullable) */
  baseUrl: string | null;
  /** API status */
  status: string;
  /** Is flagship API */
  isFlagship: boolean;
  /** Changelog URL (nullable) */
  changelogUrl: string | null;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  changelogs: {
    /** Changelog entry ID */
    id: number;
    /** Exchange API ID */
    exchangeApiId: number;
    /** Change date */
    date: string;
    /** Change title */
    title: string;
    /** Change description (nullable) */
    description: string | null;
    /** Source URL (nullable) */
    sourceUrl: string | null;
    /** Creation timestamp */
    createdAt: string;
  }[];
}[];
export type GetExchangeSyncLogsResponse = {
  /** Sync log ID */
  id: number;
  /** Exchange ID */
  exchangeId: number;
  /** Sync status */
  status: 'RUNNING' | 'COMPLETED' | 'FAILED' | 'SKIPPED';
  /** Sync start timestamp */
  startedAt: string;
  /** Sync completion timestamp (nullable) */
  completedAt: string | null;
  /** Entries found count */
  entriesFound: number;
  /** Entries added count */
  entriesAdded: number;
  /** Total prompt tokens used (nullable) */
  totalPromptTokens: number | null;
  /** Total completion tokens used (nullable) */
  totalCompletionTokens: number | null;
  /** Total inference time in milliseconds (nullable) */
  totalInferenceTimeMs: number | null;
  /** Estimated cost in USD (nullable) */
  estimatedCostUsd: number | null;
  /** Extraction method used (direct, stagehand, cached, or comma-separated per API; nullable) */
  extractionMethod: string | null;
  /** Error message (nullable) */
  errorMessage: string | null;
  /** What triggered the sync */
  triggeredBy: string;
}[];
export type ListExchangeIpsResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
}[];
export type CreateExchangeIpResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type CreateExchangeIpBody = {
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Transport the IP serves: 'mm' or 'es' */
  usage: 'mm' | 'es';
  /** Whether this IP is used by the monitoring system */
  isMonitoring?: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi?: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading?: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description?: null | string;
};
export type UpdateExchangeIpResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type UpdateExchangeIpBody = {
  /** A single IPv4 or IPv6 address */
  address?: string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring?: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi?: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading?: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description?: null | string;
};
export type DeleteExchangeIpResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type ListExchangeRegionsResponse = {
  /** Link ID */
  id: number;
  /** Exchange ID */
  exchangeId: number;
  /** Region ID */
  regionId: number;
  /** Transport the region is linked for */
  usage: string;
  /** Creation timestamp */
  createdAt: string;
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  updatedBy: number;
}[];
export type CreateExchangeRegionResponse = {
  /** Link ID */
  id: number;
  /** Exchange ID */
  exchangeId: number;
  /** Region ID */
  regionId: number;
  /** Transport the region is linked for */
  usage: string;
  /** Creation timestamp */
  createdAt: string;
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  updatedBy: number;
};
export type CreateExchangeRegionBody = {
  /** Region to inherit IPs from */
  regionId: number;
  /** Transport the IP serves: 'mm' or 'es' */
  usage: 'mm' | 'es';
};
export type DeleteExchangeRegionResponse = {
  /** Link ID */
  id: number;
  /** Exchange ID */
  exchangeId: number;
  /** Region ID */
  regionId: number;
  /** Transport the region is linked for */
  usage: string;
  /** Creation timestamp */
  createdAt: string;
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  updatedBy: number;
};
